export default {"src":"/_next/static/media/history.36b9eba1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};